<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			return (this.item.game.rank) ? this.item.game.rank : '-'

		}

	}

}

</script>

<style scoped>

</style>